import React, { FC } from "react";
import { FormGroup, Label, Input } from "../../UI/Forms/FormElements";
import { Anchor } from "../../UI/Anchor";
import { Button } from "../../UI/Button";
import { UnpackNestedValue, useForm } from "react-hook-form";
import { hasKey } from "../../../utils/methods";
import { StyledWrap, StyledTitle, StyledDesc, StyledLabelWrap } from "./style";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
import { useStores } from "../../../hooks/useStores";
import { observer } from "mobx-react";

type Props = {
  handleLogin: (email: string, password: string) => any;
};

const SigninForm: FC<Props> = observer(({ handleLogin }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { session } = useStores();
  const { t } = useTranslation();

  const onSubmit = (data: UnpackNestedValue<any>) => {
    handleLogin(data.email, data.password);
  };

  if (session.isLogged) {
    return <Redirect to={"/"} />;
  }

  return (
    <StyledWrap>
      <StyledTitle>{t("components.SigninForm.title")}</StyledTitle>
      <StyledDesc>{t("components.SigninForm.description")}</StyledDesc>
      <form action="#" onSubmit={handleSubmit(onSubmit)} noValidate>
        <FormGroup mb="20px">
          <Label display="block" mb="5px" htmlFor="email">
            {t("components.SigninForm.email")}
          </Label>
          <Input
            type="email"
            id="email"
            placeholder={t("components.SigninForm.emailPlaceholder")}
            feedbackText={errors?.email?.message?.toString()}
            state={hasKey(errors, "email") ? "error" : "success"}
            showState={!!hasKey(errors, "email")}
            {...register("email", {
              required: "" + t("components.SigninForm.emailRequired"),
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "" + t("components.SigninForm.emailInvalid"),
              },
            })}
          />
        </FormGroup>
        <FormGroup mb="20px">
          <StyledLabelWrap>
            <Label display="block" mb="5px" htmlFor="password">
              {t("components.SigninForm.password")}
            </Label>
            <Anchor path="/forgot-password" fontSize="13px">
              {t("components.SigninForm.forgotPassword")}
            </Anchor>
          </StyledLabelWrap>
          <Input
            id="password"
            type="password"
            placeholder={t("components.SigninForm.passwordPlaceholder")}
            feedbackText={errors?.password?.message?.toString()}
            state={hasKey(errors, "password") ? "error" : "success"}
            showState={!!hasKey(errors, "password")}
            {...register("password", {
              required: "" + t("components.SigninForm.passwordRequired"),
              minLength: {
                value: 8,
                message: "" + t("components.SigninForm.passwordInvalid"),
              },
            })}
          />
        </FormGroup>
        <Button type="submit" color="brand2" fullwidth>
          {t("components.SigninForm.title")}
        </Button>
      </form>
    </StyledWrap>
  );
});

export default SigninForm;
